var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome2 = function SvgHome2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    fill: "none",
    viewBox: "0 0 75 75"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "m9.97 34.054 25.596-20.632c.19-.152.505-.324.872-.458.367-.133.747-.214 1.062-.214.26 0 .612.078.972.212.358.135.673.307.864.46l25.596 20.632c.074.154.095.22.095.266v.034l-.003.064-1.312 1.687a1 1 0 0 1-.155.057h-.003a1 1 0 0 1-.123-.027l-.03-.009-.094-.027-4.432-3.732v28.32c0 .583-.537 1.063-1.062 1.063H17.188c-.603 0-1.063-.46-1.063-1.062V32.405l-4.642 3.69-.02.02-.017.012-.048.029-.01.004a.4.4 0 0 1-.114-.04l-.012-.023-1.384-1.68a.5.5 0 0 1-.003-.097c0-.045.022-.112.095-.266m27.784-18.478a.86.86 0 0 1 .465.202L56.75 30.664v28.962H44.813V41.938c0-.229-.12-.498-.342-.721s-.493-.342-.721-.342h-12.5c-.583 0-1.062.537-1.062 1.063v17.687H18.25V30.663L36.683 15.78a.86.86 0 0 1 .442-.201c.115-.02.223-.02.272-.02h.018c.089 0 .217 0 .339.018m4.934 44.049V43H32.312v16.625z",
    clipRule: "evenodd"
  })));
};
export default SvgHome2;